import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { StationUploadPage } from './StationUploadPage';

/**
 * Wraps the upload page in the audit station layout for station-scoped audit routes.
 */
export function AuditUploadPageAdapter() {
  return (
    <AuditStationPage>
      <StationUploadPage />
    </AuditStationPage>
  );
}
